const dateFmt = new Intl.DateTimeFormat("pt-BR", {
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
});

export function formatDate(input: string | Date | null | undefined): string {
  if (!input) return "";

  if (typeof input === "string") {
    const [year, month, day] = input.split("-");
    if (!year || !month || !day || isNaN(+year) || isNaN(+month) || isNaN(+day))
      return "";
    return `${day}/${month}/${year}`;
  }

  if (isNaN(input.getTime())) return "";
  return dateFmt.format(input);
}
